export default __webpack_public_path__ + "static/STAYTRUE_YELLOW-75a1a3683aa6c02f787292646884c67d.png";